import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

import { mapViewBoundaryEvent } from 'tag-manager/map_view_boundary'
import { mapViewHeatmapEvent } from 'tag-manager/map_view_heatmap'
import { mapViewHexagonEvent } from 'tag-manager/map_view_hexagon'
import { mapViewMarkerEvent } from 'tag-manager/map_view_marker'

export const LAYER_TYPES = {
  MARKER: 'marker',
  HEATMAP: 'heat-map',
  HEXAGON: 'hexagon',
  BOUNDARIES: 'boundaries'
}

export const LAYER_TYPE_TITLE = {
  [LAYER_TYPES.MARKER]: 'Marker map',
  [LAYER_TYPES.HEATMAP]: 'Heatmap',
  [LAYER_TYPES.HEXAGON]: 'Hexagon map',
  [LAYER_TYPES.BOUNDARIES]: 'Boundaries map'
}

const layerTypeEvents = {
  [LAYER_TYPES.MARKER]: mapViewMarkerEvent,
  [LAYER_TYPES.HEATMAP]: mapViewHeatmapEvent,
  [LAYER_TYPES.HEXAGON]: mapViewHexagonEvent,
  [LAYER_TYPES.BOUNDARIES]: mapViewBoundaryEvent
}

const initialState = {
  layerType: LAYER_TYPES.MARKER,
  layerTypeTitle: LAYER_TYPE_TITLE[LAYER_TYPES.MARKER]
}

export const layerTypeSlice = createSlice({
  name: 'layerType',
  initialState,
  reducers: {
    setLayerType: (state, action) => {
      const layerType = action.payload
      layerTypeEvents[layerType]?.()
      state.layerType = layerType
    },
    setLayerTypeTitle: (state, action) => {
      state.layerTypeTitle = action.payload
    }
  }
})

export const { setLayerType, setLayerTypeTitle } = layerTypeSlice.actions

export const selectLayerType = (state) => state.layerType.layerType
const selectLayerTypeTitle = (state) => state.layerType.layerTypeTitle

export const useLayerType = () => useSelector(selectLayerType)
export const useLayerTypeTitle = () => useSelector(selectLayerTypeTitle)

export default layerTypeSlice.reducer
